export const countOrNull = (n, loading, failed) => (loading || failed ? null : n);
